
import { Group } from "@/lib/types";
import { GroupCard } from "./GroupCard";
import { DirectMessageDialog } from "../messages/DirectMessageDialog";
import { Badge } from "../ui/badge";

interface GroupListProps {
  groups: Group[];
  onJoinGroup: (groupId: string) => Promise<void>;
  selectedGroup: string | null;
  setSelectedGroup: (groupId: string | null) => void;
  userRoles: Record<string, string>;
}

export const GroupList = ({
  groups,
  onJoinGroup,
  selectedGroup,
  setSelectedGroup,
  userRoles,
}: GroupListProps) => {
  if (!groups.length) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No groups found
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {groups.map((group) => (
        <GroupCard
          key={group.id}
          group={group}
          isSelected={selectedGroup === group.id}
          onSelect={setSelectedGroup}
          onJoin={onJoinGroup}
          userRole={userRoles[group.id]}
          actionButton={
            group.created_by && (
              <DirectMessageDialog
                recipientId={group.created_by}
                recipientName={group.name}
              />
            )
          }
        />
      ))}
    </div>
  );
};
